import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import './css/GameStats1.css';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { randomNumber } from '../../../../catalog/Others';
import { getOptimXBackgroundStyle } from '../../../../catalog/Website';
import { context } from '../../../../globalState/GlobalState';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { opponentBlocksDescription, opponentGoalsDescription, opponentPenaltiesDescription, opponentPowerplaysDescription, opponentSavesDescription, opponentShotsDescription, ourBlocksDescription, ourGoalsDescription, ourPenaltiesDescription, ourPowerplaysDescription, ourSavesDescription, ourShotsDescription } from '../../../../catalog/stats/iceHockey/IceHockeyStatsDescription';
import { opponentBlocksFromGame, opponentGoalsFromGame, opponentPenaltiesFromGame, opponentPowerplaysFromGame, opponentSavesFromGame, opponentShotsFromGame, ourBlocksFromGame, ourGoalsFromGame, ourPenaltiesFromGame, ourPowerplaysFromGame, ourSavesFromGame, ourShotsFromGame } from '../../../../catalog/stats/iceHockey/IceHockeyGameStats';

const IceHockeyGameStats1 = (props) => {
    const { game, opponentName, opponentLogo, homeGame } = props;
    const { globalState } = useContext(context);

    const getRow1 = (summaryLeft, summaryMiddle, summaryRight, themeLeft, leftBarWidth, rightBarWidth, detailsLeft, detailsRight) => {
        return (
            <Accordion
                className="full-width"
            >
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    TransitionProps={{ unmountOnExit: true }}
                >
                    <div className="game-stats1-stats-row-container full-width">
                        <div className="game-stats1-stats-row full-width">
                            <p className="m-t-10px m-b-10px font-size-2xl m-l-30px">{summaryLeft}</p>
                            <p className="m-t-10px m-b-10px font-size-2xl text-lightgray text-uppercase">{summaryMiddle}</p>
                            <p className="m-t-10px m-b-10px font-size-2xl m-r-0">{summaryRight}</p>
                        </div>
                        <div className="game-stats1-stats-bottom-bar">
                            {themeLeft ? (
                                <>
                                    <div style={{ ...getOptimXBackgroundStyle(globalState), height: '100%', width: leftBarWidth }}></div>
                                    <div style={{ backgroundColor: 'silver', height: '100%', width: rightBarWidth }}></div>
                                </>
                            ) : (
                                <>
                                    <div style={{ backgroundColor: 'silver', height: '100%', width: leftBarWidth }}></div>
                                    <div style={{ ...getOptimXBackgroundStyle(globalState), height: '100%', width: rightBarWidth }}></div>
                                </>
                            )}
                        </div>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <div className="team-row full-width p-t-15px p-b-15px">
                        <div className="left-team-column half-width">
                            {detailsLeft.map((detail) => {
                                return (
                                    detail ? <div key={randomNumber()} className="stat-detail normal-font-family text-uppercase text-left-align font-size-xs m-t-3px m-b-3px m-l-30px">{detail}</div> : null
                                );
                            })}
                        </div>
                        <div className="right-team-column half-width">
                            {detailsRight.map((detail) => {
                                return (
                                    detail ? <div key={randomNumber()} className="stat-detail normal-font-family text-uppercase text-right-align font-size-xs m-t-3px m-b-3px m-r-30px">{detail}</div> : null
                                );
                            })}
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        );
    };

    return (
        <div className="game-stats1-container-container x-center">
            {!homeGame ? (
                <>
                    <div className="game-stats1-scorecard x-center m-t-30px">
                        <div className="game-stats1-scorecard-team">
                            {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                                <>
                                    <img className="game-stats1-scorecard-logo" src={globalState.logo.logo2} alt={globalState.teamAlias} />
                                    <p className="game-stats1-scorecard-title font-size-xl text-uppercase m-t-20px m-b-0">{globalState.teamAlias}</p>
                                </>
                            ) : (
                                <p className="game-stats1-scorecard-title font-size-xl text-uppercase m-t-20px m-b-0">{globalState.teamAlias}</p>
                            )}
                        </div>
                        <p className="game-stats1-scorecard-vs font-size-6xl font-weight-500 m-t-20px m-b-0 normal-font-family">vs</p>
                        <div className="game-stats1-scorecard-team">
                            {isValidString(opponentLogo) ? (
                                <>
                                    <img className="game-stats1-scorecard-logo" src={opponentLogo} alt={opponentName} />
                                    <p className="game-stats1-scorecard-title font-size-xl text-uppercase m-t-20px m-b-0">{opponentName}</p>
                                </>
                            ) : (
                                <p className="game-stats1-scorecard-title font-size-xl text-uppercase m-t-20px m-b-0">{opponentName}</p>
                            )}
                        </div>
                    </div>
                    <div className="game-stats1-stats x-center m-t-30px m-b-100px box-shadow-black p-l-0 p-r-0 curve-border-10px">
                        {getRow1(
                            ourGoalsFromGame(game),
                            'Goals',
                            opponentGoalsFromGame(game),
                            true,
                            `${(100 * ourGoalsFromGame(game)) / (ourGoalsFromGame(game) + opponentGoalsFromGame(game))}%`,
                            `${(100 * opponentGoalsFromGame(game)) / (ourGoalsFromGame(game) + opponentGoalsFromGame(game))}%`,
                            ourGoalsDescription(game.goals),
                            opponentGoalsDescription(game.goals),
                        )}
                        {getRow1(
                            ourShotsFromGame(game),
                            'Shots',
                            opponentShotsFromGame(game),
                            true,
                            `${(100 * ourShotsFromGame(game)) / (ourShotsFromGame(game) + opponentShotsFromGame(game))}%`,
                            `${(100 * opponentShotsFromGame(game)) / (ourShotsFromGame(game) + opponentShotsFromGame(game))}%`,
                            ourShotsDescription(game.highlightsPerPeriod),
                            opponentShotsDescription(game.highlightsPerPeriod),
                        )}
                        {getRow1(
                            ourSavesFromGame(game),
                            'Saves',
                            opponentSavesFromGame(game),
                            true,
                            `${(100 * ourSavesFromGame(game)) / (ourSavesFromGame(game) + opponentSavesFromGame(game))}%`,
                            `${(100 * opponentSavesFromGame(game)) / (ourSavesFromGame(game) + opponentSavesFromGame(game))}%`,
                            ourSavesDescription(game.highlightsPerPeriod),
                            opponentSavesDescription(game.highlightsPerPeriod),
                        )}
                        {getRow1(
                            ourBlocksFromGame(game),
                            'Blocks',
                            opponentBlocksFromGame(game),
                            true,
                            `${(100 * ourBlocksFromGame(game)) / (ourBlocksFromGame(game) + opponentBlocksFromGame(game))}%`,
                            `${(100 * opponentBlocksFromGame(game)) / (ourBlocksFromGame(game) + opponentBlocksFromGame(game))}%`,
                            ourBlocksDescription(game.highlightsPerPeriod),
                            opponentBlocksDescription(game.highlightsPerPeriod),
                        )}
                        {getRow1(
                            ourPowerplaysFromGame(game),
                            'Powerplays',
                            opponentPowerplaysFromGame(game),
                            true,
                            `${(100 * ourPowerplaysFromGame(game)) / (ourPowerplaysFromGame(game) + opponentPowerplaysFromGame(game))}%`,
                            `${(100 * opponentPowerplaysFromGame(game)) / (ourPowerplaysFromGame(game) + opponentPowerplaysFromGame(game))}%`,
                            ourPowerplaysDescription(game.powerplays),
                            opponentPowerplaysDescription(game.powerplays),
                        )}
                        {getRow1(
                            ourPenaltiesFromGame(game),
                            'Penalties',
                            opponentPenaltiesFromGame(game),
                            true,
                            `${(100 * ourPenaltiesFromGame(game)) / (ourPenaltiesFromGame(game) + opponentPenaltiesFromGame(game))}%`,
                            `${(100 * opponentPenaltiesFromGame(game)) / (ourPenaltiesFromGame(game) + opponentPenaltiesFromGame(game))}%`,
                            ourPenaltiesDescription(game.penalties),
                            opponentPenaltiesDescription(game.penalties),
                        )}
                    </div>
                </>
            ) : (
                <>
                    <div className="game-stats1-scorecard x-center m-t-30px">
                        <div className="game-stats1-scorecard-team">
                            {isValidString(opponentLogo) ? (
                                <>
                                    <img className="game-stats1-scorecard-logo" src={opponentLogo} alt={opponentName} />
                                    <p className="game-stats1-scorecard-title font-size-xl text-uppercase m-t-20px m-b-0">{opponentName}</p>
                                </>
                            ) : (
                                <p className="game-stats1-scorecard-title font-size-xl text-uppercase m-t-20px m-b-0">{opponentName}</p>
                            )}
                        </div>
                        <p className="font-size-6xl text-lightgray m-t-0 m-b-0">vs</p>
                        <div className="game-stats1-scorecard-team">
                            {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                                <>
                                    <img className="game-stats1-scorecard-logo" src={globalState.logo.logo2} alt={globalState.teamAlias} />
                                    <p className="game-stats1-scorecard-title font-size-xl text-uppercase m-t-20px m-b-0">{globalState.teamAlias}</p>
                                </>
                            ) : (
                                <p className="game-stats1-scorecard-title font-size-xl text-uppercase m-t-20px m-b-0">{globalState.teamAlias}</p>
                            )}
                        </div>
                    </div>
                    <div className="game-stats1-stats x-center m-t-30px m-b-100px box-shadow-black p-l-0 p-r-0 curve-border-10px">
                        {getRow1(
                            opponentGoalsFromGame(game),
                            'Goals',
                            ourGoalsFromGame(game),
                            false,
                            `${(100 * opponentGoalsFromGame(game)) / (ourGoalsFromGame(game) + opponentGoalsFromGame(game))}%`,
                            `${(100 * ourGoalsFromGame(game)) / (ourGoalsFromGame(game) + opponentGoalsFromGame(game))}%`,
                            opponentGoalsDescription(game.goals),
                            ourGoalsDescription(game.goals),
                        )}
                        {getRow1(
                            opponentShotsFromGame(game),
                            'Shots',
                            ourShotsFromGame(game),
                            false,
                            `${(100 * opponentShotsFromGame(game)) / (ourShotsFromGame(game) + opponentShotsFromGame(game))}%`,
                            `${(100 * ourShotsFromGame(game)) / (ourShotsFromGame(game) + opponentShotsFromGame(game))}%`,
                            opponentShotsDescription(game.highlightsPerPeriod),
                            ourShotsDescription(game.highlightsPerPeriod),
                        )}
                        {getRow1(
                            opponentSavesFromGame(game),
                            'Saves',
                            ourSavesFromGame(game),
                            false,
                            `${(100 * opponentSavesFromGame(game)) / (ourSavesFromGame(game) + opponentSavesFromGame(game))}%`,
                            `${(100 * ourSavesFromGame(game)) / (ourSavesFromGame(game) + opponentSavesFromGame(game))}%`,
                            opponentSavesDescription(game.highlightsPerPeriod),
                            ourSavesDescription(game.highlightsPerPeriod),
                        )}
                        {getRow1(
                            opponentBlocksFromGame(game),
                            'Blocks',
                            ourBlocksFromGame(game),
                            false,
                            `${(100 * opponentBlocksFromGame(game)) / (ourBlocksFromGame(game) + opponentBlocksFromGame(game))}%`,
                            `${(100 * ourBlocksFromGame(game)) / (ourBlocksFromGame(game) + opponentBlocksFromGame(game))}%`,
                            opponentBlocksDescription(game.highlightsPerPeriod),
                            ourBlocksDescription(game.highlightsPerPeriod),
                        )}
                        {getRow1(
                            opponentPowerplaysFromGame(game),
                            'Powerplays',
                            ourPowerplaysFromGame(game),
                            false,
                            `${(100 * opponentPowerplaysFromGame(game)) / (ourPowerplaysFromGame(game) + opponentPowerplaysFromGame(game))}%`,
                            `${(100 * ourPowerplaysFromGame(game)) / (ourPowerplaysFromGame(game) + opponentPowerplaysFromGame(game))}%`,
                            opponentPowerplaysDescription(game.powerplays),
                            ourPowerplaysDescription(game.powerplays),
                        )}
                        {getRow1(
                            opponentPenaltiesFromGame(game),
                            'Penalties',
                            ourPenaltiesFromGame(game),
                            true,
                            `${(100 * opponentPenaltiesFromGame(game)) / (ourPenaltiesFromGame(game) + opponentPenaltiesFromGame(game))}%`,
                            `${(100 * ourPenaltiesFromGame(game)) / (ourPenaltiesFromGame(game) + opponentPenaltiesFromGame(game))}%`,
                            opponentPenaltiesDescription(game.penalties),
                            ourPenaltiesDescription(game.penalties),
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

IceHockeyGameStats1.propTypes = {
    game: PropTypes.object.isRequired,
    opponentName: PropTypes.string.isRequired,
    opponentLogo: PropTypes.string.isRequired,
    homeGame: PropTypes.bool.isRequired,
};

export default memo(IceHockeyGameStats1);
